export default __webpack_public_path__ + "static/media/donation2.7d050746.png";